import React, { Fragment, useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { withTranslation } from "react-i18next";
import { toast } from "react-toastify";
import AssignSubscriptionService from "../../../core/service/AssignSubscriptionService";
import CompanyService from "../../../core/service/CompanyService";
import DashGraphConfigService from "../../../core/service/DashGraphConfigService";

const AssignSetToCompanyModal = ({ t, show, onClose, graphSet, onSaved }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [companyId, setCompanyId] = useState(0);
  const [saving, setSaving] = useState(false);

  const filterBy = () => true;

  const handleClose = () => {
    setCompanies([]);
    setCompanyId(0);
    onClose();
  };

  const handleSearch = (query) => {
    setIsLoading(true);
    AssignSubscriptionService.getCompanyList(query)
      .then((res) => {
        setIsLoading(false);
        if (res.status !== 200) return;

        setCompanies(res.data?.map((i) => ({ id: i.companyId, legalName: i.legalName })));
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  const handleAssign = () => {
    if (companyId <= 0 || !standardId) return;

    setSaving(true);
    DashGraphConfigService.assignSetToCompany(graphSet.id, companyId, Number(standardId))
      .then((res) => {
        setSaving(false);
        if (res.status !== 200 && res.status !== 201 && res.status !== 204) return;

        toast.success("Success", { position: toast.POSITION.TOP_RIGHT });
        handleClose();
        if (onSaved) onSaved();
      })
      .catch(() => {
        setSaving(false);
      });
  };

  const [standards, setStandards] = useState([]);
  const [standardId, setStandardId] = useState("");

  useEffect(() => {
    setStandards([]);
    setStandardId("");
    if (companyId <= 0) return;

    CompanyService.getCompanySubscriptions(companyId, "S")
      .then((res) => {
        if (res.status !== 200) return;
        setStandards([...(res.data?.regulations || [])]);
      })
      .catch(() => {});
  }, [companyId]);

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{t("AssignCompany.label")}{graphSet ? ` - ${graphSet.name}` : ""}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>{t("company.label")} <span className="text-red">*</span></Form.Label>
          <AsyncTypeahead
            filterBy={filterBy}
            id="graphSetCompany"
            isLoading={isLoading}
            labelKey="legalName"
            minLength={2}
            onSearch={handleSearch}
            onChange={(selected) => setCompanyId(selected[0] ? selected[0].id : 0)}
            options={companies}
            placeholder={t("Search.label")}
            renderMenuItemChildren={(option) => (
              <Fragment>
                <span>{option.legalName}</span>
              </Fragment>
            )}
          />
        </Form.Group>
        {companyId > 0 && (
          <Form.Group className="mt-3">
            <Form.Label>{t("Standard.label")} <span className="text-red">*</span></Form.Label>
            <Form.Select value={standardId} onChange={(e) => setStandardId(e.target.value)}>
              <option value="">{t("Select.label")}</option>
              {standards.map((s) => (
                <option value={s.id} key={s.id}>{s.name}</option>
              ))}
            </Form.Select>
          </Form.Group>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={handleClose}>
          {t("Cancel.label")}
        </Button>
        <Button variant="primary" disabled={companyId <= 0 || !standardId || saving} onClick={handleAssign}>
          {t("Assign.label")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default withTranslation()(AssignSetToCompanyModal);
